import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, timer } from 'rxjs';
import {
    IndicatorState,
    SbPendingButtonIndicatorComponent
} from '../../../../../shared/components/sb-pending-button-indicator/sb-pending-button-indicator.component';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { RouterLink } from '@angular/router';
import { TestSelectorDirective } from '../../../../../shared/directives/test-selector.directive';
import { SyncAccountingService } from '../../services/sync-accounting.service';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { share, switchMap, takeUntil, takeWhile } from 'rxjs/operators';

@Component({
    selector: 'sb-accounting-calculations-trigger',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        ReactiveFormsModule,
        RouterLink,
        TestSelectorDirective,
        IconsModule,
        SbPendingButtonIndicatorComponent
    ],
    templateUrl: './sb-accounting-calculations-trigger.component.html'
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SbAccountingCalculationsTriggerComponent implements OnInit, OnDestroy {
    constructor(
        private accountingService: SyncAccountingService,
        private toast: ToastService
    ) {}

    unsubscribe$ = new Subject();
    state: IndicatorState = null;
    status$ = timer(1, 3000).pipe(
        takeUntil(this.unsubscribe$),
        switchMap(() => this.accountingService.fetchCalculationStatus()),
        share(),
        takeWhile((calc) => calc.status, true)
    );

    ngOnInit(): void {
        this.status$.subscribe((res) => {
            this.state = res.status ? 'loading' : null;
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    runCalc() {
        this.state = 'loading';
        this.accountingService.recalculateAsync().subscribe(
            (_) => {
                this.status$.subscribe((res) => {
                    this.state = res.status ? 'loading' : null;
                });
                this.toast.show({
                    intent: 'success',
                    message: 'Starting calculations..',
                    title: 'Success!'
                });
            },
            (res) => {
                this.state = 'error';
                this.toast.show({
                    intent: 'critical',
                    message: `Failed to run calculations, "${res.error.status}"`,
                    title: 'Oops!'
                });
            }
        );
    }
}
